export const CURRENT_SCORE_INPUT_TYPE = "score_input_2022";
export const SCORE_INPUT_TYPE_2023 = "score_input_2023";
export const SCORE_INPUT_TYPE_2024 = "score_input_2024";
export const SCORE_INPUT_TYPE_2025 = "score_input_2025";
export const SCORE_INPUT_TYPE_2026 = "score_input_2026";
export const SCORE_INPUT_TYPE_2027 = "score_input_2027";
export const CURRENT_SCORE_INPUT_RESPONSE_TYPE = 'score_input'